module.exports = __webpack_public_path__ + "img/addCase.113fd14f.png";